<ng-container [caLocalizationScope]="localizationKey">
  <div *ngIf="isSurveillanceSecurity$ | async">
    <span class="text-muted body-50" data-automation-id="surveillance-marker">{{
      'surveillanceDataInfo' | caLocalize
    }}</span>
  </div>
</ng-container>
